import { render, staticRenderFns } from "./Fastpay.vue?vue&type=template&id=729ba812&scoped=true"
import script from "./Fastpay.vue?vue&type=script&lang=js"
export * from "./Fastpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ba812",
  null
  
)

export default component.exports